import { HTTP } from '../http'
import axios from 'axios'

export const doAsync = (store, { url, mutationType, method = 'get', data = {}, postSuccess = null, responseType }) => {
  if (postSuccess) {
    // Post success is sometimes passed in, but it unclear what the intention is/was
    // For now (Feb2020) just keeping the linter happy
    console.log('doAsync postSuccess', postSuccess)
  }
  if (mutationType) {
    store.commit(mutationType.PENDING)
  }

  return new Promise((resolve, reject) => {
    HTTP({ method, url, data, responseType })
      .then(response => {
        if (mutationType) {
          store.commit(mutationType.PENDING, false)
          store.commit(mutationType.SUCCESS, response.data)
        }
        resolve(response)
      })
      .catch(error => {
        if (mutationType) {
          store.commit(mutationType.PENDING, false)
          // Typically we use the error_description key but for password reset the api can only return an "message" key
          store.commit(mutationType.FAILURE, error.response.data.error_description || error.response.data.message || error.response.data.error)
        }
        reject(error)
      })
  })
}

export const authAsync = (store, { url, mutationType, method = 'get', data = {}, postSuccess = null }) => {
  if (postSuccess) {
    // Post success is sometimes passed in, but it unclear what the intention is/was
    // For now (Feb2020) just keeping the linter happy
    console.log('authAsync postSuccess', postSuccess)
  }
  if (mutationType) {
    store.commit(mutationType.PENDING)
  }

  const AUTHHTTP = axios.create({
    baseURL: window.api_path,
    auth: {
      username: process.env.VUE_APP_API_USER,
      password: process.env.VUE_APP_API_PASS
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })

  AUTHHTTP.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.status === 503) {
        store.dispatch('maintenance/show', error.response?.data)
      }
      return Promise.reject(error)
    }
  )

  console.log('AUTH ASYNC')

  return new Promise((resolve, reject) => {
    AUTHHTTP({ method, url, data })
      .then(response => {
        if (mutationType) {
          store.commit(mutationType.PENDING, false)
          store.commit(mutationType.SUCCESS, response.data)
        }
        resolve(response)
      })
      .catch(error => {
        if (mutationType) {
          store.commit(mutationType.PENDING, false)
          // Typically we use the error_description key but for password reset the api can only return an "message" key
          store.commit(mutationType.FAILURE, error.response.data.error_description || error.response.data.message || error.response.data.error)
        }
        reject(error)
      })
  })
}
